/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Info_Due_Date_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to update due date: {error}" |
*
* @param {Explorer_Info_Due_Date_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_failed_toast = /** @type {((inputs: Explorer_Info_Due_Date_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to update due date: ${i?.error}`)
});